import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Games() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 0 40px 0",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 12,
            }}
          >
            Games
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#333",
              marginBottom: 32,
              maxWidth: 600,
              textAlign: "center",
            }}
          >
            Explore exciting coding games like Car Racing, Space Defenders, and
            Tic Tac Toe.
          </p>
          <Link
            to="/offline-games"
            style={{
              display: "inline-block",
              background: "#1976d2",
              color: "#fff",
              fontWeight: 600,
              textDecoration: "none",
              fontSize: "1.05rem",
              padding: "10px 20px",
              borderRadius: 10,
              marginBottom: 32,
              boxShadow: "0 2px 10px rgba(25,118,210,0.25)",
            }}
          >
            🎮 Offline Downloadable Games for Students
          </Link>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 40,
              marginBottom: 40,
            }}
          >
            {/* Car Game */}
            <Link to="/car-game" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/car_game.gif"
                  alt="Car Game"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                }}
              />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Car Game
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Enjoy this fun car racing game coded in Python.
              </p>
              <a
                href="/Car game.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download Car game.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to play the car racing game.
              </div>
            </div>
            </Link>
            {/* Space Defenders */}
            <Link to="/space-defenders" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/space_defenders.gif"
                  alt="Space Defenders"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                }}
              />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Space Defenders
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Defend your spaceship in this exciting Python game.
              </p>
              <a
                href="/Space defenders.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download Space defenders.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to defend your spaceship.
              </div>
            </div>
            </Link>
            {/* Tic Tac Toe */}
            <Link to="/tic-tac-toe" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 200,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageWithFallback
                  src="/tic_tac_toe.gif"
                  alt="Tic Tac Toe"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 18,
                }}
              />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Tic Tac Toe
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Play the classic Tic Tac Toe game coded in Python.
              </p>
              <a
                href="/tic_tac_toe.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download tic_tac_toe.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to play Tic Tac Toe.
              </div>
            </div>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default Games;
